module.exports = __webpack_public_path__ + "static/media/pumpwhiz-2.cd175cfb.png";